import { render } from "./PageAddRiwayat.vue?vue&type=template&id=8c6178e2"
import script from "./PageAddRiwayat.vue?vue&type=script&lang=js"
export * from "./PageAddRiwayat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__